// extracted by mini-css-extract-plugin
export default {"title":"Title_title__s27o6","myname":"Title_myname__Wv5KU"};